import React from 'react';
import Skeleton from 'react-loading-skeleton';
import VacationSuggestionCardSkeleton from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/vacationSuggestionCardSkeleton';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';
import { dispatchTrackingEvent, VACATION_SUGGESTION } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';
import DragScrollWrapper from '@PROJECT_ROOT/assets/responsive-frontend/parts/DragScrollWrapper/DragScrollWrapper';
import HorizontalScrollArrows from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/HorizontalScrollArrows';

export default class VacationSuggestions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            itemsScrollableElement: null,
        };
        this.itemWidthPx = 194;
        this.itemWidthPxMobile = 120;
        this.itemsGapPx = 16;
        this.scrollAnimationDurationMs = 500;
    }

    render() {
        const { data, isLoading } = this.props;
        const { itemsScrollableElement } = this.state;

        return (
            <div className="vacationSuggestions">
                <div className="vacationSuggestions--header">
                    <h2>{isLoading ? <Skeleton /> : data.title}</h2>
                    <div className="line" />
                </div>
                <div className="px-0 position-static">
                    <DragScrollWrapper
                        ref={(el) => {
                            if (el && el !== itemsScrollableElement) {
                                this.setState({ itemsScrollableElement: el });
                            }
                        }}
                        className="vacationSuggestionsOuter"
                        handleOnScroll={this.handleScroll}
                        horizontal={true}
                        vertical={false}
                    >
                        {isLoading ? (
                            <>
                                <VacationSuggestionCardSkeleton />
                                <VacationSuggestionCardSkeleton />
                                <VacationSuggestionCardSkeleton />
                                <VacationSuggestionCardSkeleton />
                                <VacationSuggestionCardSkeleton />
                                <VacationSuggestionCardSkeleton />
                                <VacationSuggestionCardSkeleton />
                                <VacationSuggestionCardSkeleton />
                            </>
                        ) : (
                            data?.items?.map((item, index) => (
                                <div
                                    className="vacationSuggestionsItem"
                                    key={index}
                                >
                                    <a
                                        href={item.hyperlink.redirectURL}
                                        className="item-link"
                                        title={item.hyperlink.seoTitle}
                                        onClick={() => {
                                            if (!IS_FRAME_SERVICE) dispatchTrackingEvent(VACATION_SUGGESTION);
                                        }}
                                    >
                                        <div className="item-content">
                                            <div className="item-body">
                                                <div className="item-img--wrapper">
                                                    <img
                                                        loading="lazy"
                                                        src={item.image.sourceURL}
                                                        className="item-img"
                                                        alt={item.image.altText}
                                                        title={item.image.titleText}
                                                    />
                                                </div>
                                                <div className="item-text--wrapper">
                                                    <h3 className="item-text">
                                                        {item.hyperlink.redirectURLTitle}
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            ))
                        )}
                    </DragScrollWrapper>
                </div>
                <HorizontalScrollArrows
                    scrollableElement={itemsScrollableElement}
                    scrollAmountPx={this.itemWidthPx + this.itemsGapPx}
                    scrollAmountMobilePx={this.itemWidthPxMobile + this.itemsGapPx}
                    durationMs={this.scrollAnimationDurationMs}
                    alignRight={true}
                />
            </div>
        );
    }
}
